import { useCallback } from "react";
import { useSettings } from "./settings";

export const SCHEMA = [
  { title: "Bandeau du haut et menu", fields: [
    ["announce", "Bandeau d'annonce", "Livraison partout au Canada · Cueillette sur rendez-vous"],
    ["nav_hearts", "Menu : lien vers la section des cœurs", "Petits cœurs"],
    ["nav_cta", "Menu : bouton", "Acquérir une œuvre"],
  ] },
  { title: "Haut de page", fields: [
    ["hero_eyebrow", "Petite ligne au-dessus du titre", "Œuvres originales · Créées à la main au Québec"],
    ["hero_title1", "Grand titre, ligne 1", "L'émotion"],
    ["hero_title2", "Grand titre, ligne 2 (italique)", "en couleurs"],
    ["hero_subtitle", "Texte de présentation", "Aquarelle, acrylique, collage de papiers à motifs et filets d'or. Chaque toile est une pièce unique, pensée pour apporter douceur et lumière chez vous.", "area"],
    ["hero_cta1", "Bouton 1", "Découvrir les œuvres"],
    ["hero_cta2", "Bouton 2", "Une commande sur mesure"],
    ["hero_badge", "Texte du badge tournant", "pièce unique · signée · originale · "],
  ] },
  { title: "Galerie", fields: [
    ["gallery_eyebrow", "Petite ligne", "La boutique en ligne"],
    ["gallery_title1", "Titre, ligne 1", "La couleur au cœur"],
    ["gallery_title2", "Titre, ligne 2 (italique)", "de mes créations"],
    ["gallery_intro", "Texte d'introduction", "Œuvres originales, signées à la main. Cliquez sur une toile pour la voir de près, l'imaginer sur votre mur et la réserver.", "area"],
  ] },
  { title: "L'artiste", fields: [
    ["about_image", "Grande photo", "/images/atelier.jpg", "image"],
    ["about_image2", "Petite photo encadrée", "/images/christine.jpg", "image"],
    ["about_eyebrow", "Petite ligne", "L'artiste"],
    ["about_title1", "Titre, ligne 1", "Une artiste"],
    ["about_title2", "Titre, ligne 2 (italique)", "passionnée"],
    ["about_p1", "Paragraphe 1", "Artiste peintre québécoise, Christine travaille en techniques mixtes : aquarelle, acrylique et collage. Ses fonds en lavis pastel accueillent des sujets peints avec précision, puis habillés de papiers à motifs soulignés d'or.", "area"],
    ["about_p2", "Paragraphe 2", "Tortues, fous de Bassan, zèbres et petits cœurs : chaque toile est une pièce unique, pensée pour apporter douceur et lumière dans une pièce.", "area"],
    ["easel_image", "« Sur le chevalet » : photo", "/images/baleine.jpg", "image"],
    ["easel_title", "« Sur le chevalet » : titre", "Sur le chevalet."],
    ["easel_text", "« Sur le chevalet » : texte", "Une baleine en cours de création. Elle rejoindra la boutique à sa sortie de l'atelier.", "area"],
    ["about_cta", "Bouton", "Me contacter"],
  ] },
  { title: "Section des cœurs", fields: [
    ["hearts_eyebrow", "Petite ligne", "Des histoires"],
    ["hearts_title1", "Titre, ligne 1", "Pourquoi"],
    ["hearts_title2", "Titre, ligne 2 (italique)", "des cœurs ?"],
    ["hearts_p1", "Paragraphe 1", "Une série de petits formats qui tient une place toute particulière pour Christine. Chaque cœur est construit en spirales de papiers colorés et de filets dorés, sur un fond pastel différent.", "area"],
    ["hearts_p2", "Paragraphe 2", "C'est cette série qui a été retenue pour l'exposition De la couleur contre la douleur.", "area"],
    ["hearts_sign", "Phrase manuscrite", "un petit cœur, une grande lumière"],
  ] },
  { title: "Exposition", fields: [
    ["expo_image", "Photo de fond", "/images/coeur5.jpg", "image"],
    ["expo_eyebrow", "Petite ligne", "Prochaine exposition"],
    ["expo_dates", "Dates (grand chiffre)", "19–22"],
    ["expo_month", "Mois et année", "novembre 2026"],
    ["expo_title1", "Titre, ligne 1", "De la couleur"],
    ["expo_title2", "Titre, ligne 2 (italique)", "contre la douleur"],
    ["expo_text", "Texte", "Organisée par Artistes de cœur au profit des femmes et des enfants victimes de violence. Venez voir la série des petits cœurs en personne.", "area"],
    ["expo_place", "Lieu", "Centre multifonctionnel de Saint-Lambert"],
    ["expo_cta", "Bouton", "M'écrire au sujet de l'exposition"],
  ] },
  { title: "Contact", fields: [
    ["contact_eyebrow", "Petite ligne", "Contact & commandes"],
    ["contact_title1", "Titre, ligne 1", "Vous avez un projet"],
    ["contact_title2", "Titre, ligne 2 (italique)", "à réaliser ?"],
    ["contact_intro", "Texte", "Une toile sur commande, une question sur une œuvre, des dimensions particulières ou une visite de l'atelier : écrivez-moi et je vous répondrai rapidement.", "area"],
    ["contact_place_label", "Petit titre de l'adresse", "Atelier"],
    ["contact_place", "Adresse / précision", "Québec · visites sur rendez-vous"],
  ] },
  { title: "Infolettre", fields: [
    ["news_title", "Titre", "Abonnez-vous à l'infolettre"],
    ["news_text", "Texte", "Voir les nouvelles toiles en premier · Recevoir les dates d'expositions · Profiter d'offres réservées aux abonnés", "area"],
  ] },
  { title: "Pied de page", fields: [
    ["footer_text", "Texte sous le logo", "Œuvres originales en techniques mixtes, créées au Québec."],
    ["facebook_url", "Lien Facebook", "https://www.facebook.com/share/1HE3AmmS11/", "url"],
    ["gallea_url", "Lien Gallea", "https://gallea.ca/fr/artistes/christine-p", "url"],
    ["instagram_url", "Lien Instagram", "https://www.instagram.com/christine_artiste?exln=MXZxZnQ0b3lhZ2c3YQ%3D%3D&utm_source=qr", "url"],
    ["footer_buy1", "Achats, ligne 1", "Livraison partout au Canada"],
    ["footer_buy2", "Achats, ligne 2", "Cueillette sur rendez-vous"],
    ["footer_buy3", "Achats, ligne 3", "Prix en dollars canadiens, taxes en sus"],
    ["copyright", "Mention de droits", "© 2026 Christine P. artiste peintre"],
  ] },
];

export const CONTENT_DEFAULTS = Object.fromEntries(SCHEMA.flatMap((s) => s.fields.map(([k, , d]) => [k, d])));

export const useT = () => {
  const { settings } = useSettings();
  const c = settings.content || {};
  return useCallback((k) => (typeof c[k] === "string" && c[k].trim() ? c[k] : CONTENT_DEFAULTS[k] ?? ""), [c]);
};
